import React from "react";
import { withRouter } from "react-router-dom";
import { getCurrentSubOrderStatus, getMainSubOrder, orderIsCancelled, orderIsFullyRefunded } from "../Helpers/OderUtils";
import "../Styles/_FulfillmentInformation.css";
import { Warning } from "./_Icon";

const AuthorizedInformation = ({ currentLanguage, order }) => {
    if (orderIsCancelled(order) || orderIsFullyRefunded(order)) {
        return null;
    }

    const subOrder = getMainSubOrder(order);
    const currentStatus = getCurrentSubOrderStatus(subOrder);

    if (!currentStatus || currentStatus.status !== "AUTHORIZED") {
        return null;
    }

    return (
        <div className="fulfillment-container allow-focus" tabIndex="0">
            <div className="fulfillment-container-label">
                <Warning />
                <p>{currentLanguage.ORDER_PAGE.AUTHORIZED_SECTION.AUTHORIZED_MESSAGE}</p>
            </div>
        </div>
    );
};

export default withRouter(AuthorizedInformation);
